import React from 'react'
// eslint-disable-next-line no-unused-vars
import { Row, HeaderRow, Col } from './components'
import TriggerRow from './TriggerRow'
import R from 'ramda'
import styled from 'styled-components'
import { Button } from 'antd'
import TriggerModal from './TriggerModal'

const Filler = styled.div`
  flex: 1 1 2px;
`

const toTriggerRows = filter => save =>
  R.compose(
    R.map(trigger => (
      <TriggerRow
        key={trigger.triggerId}
        CellWrapper={Col}
        dataWidth="100px"
        save={save}
        {...trigger}
      />
    )),
    R.sortBy(d => d.name.toUpperCase()),
    R.filter(
      d =>
        filter.trim().length === 0 ||
        d.name.toLowerCase().includes(filter.toLowerCase())
    )
  )

class Trigger extends React.PureComponent {
  state = { showModal: false }
  closeModal = () => this.setState({ showModal: false })
  openModal = () => this.setState({ showModal: true })
  render() {
    const { triggers, save, filter = '' } = this.props
    const { showModal } = this.state
    return (
      <div>
        {showModal && (
          <TriggerModal
            close={this.closeModal}
            save={e => save(e).map(this.closeModal)}
            visible={showModal}
            error={this.props.error}
            setError={this.props.setError}
          />
        )}
        {triggers.length > 0 && (
          <HeaderRow>
            <Col width="130px">Trigger Type</Col>
            <Col width="200px">Trigger Name</Col>
            <Col width="100px">Hour</Col>
            <Col width="100px">Min</Col>
            <Filler />
            <Button onClick={this.openModal} style={{ marginRight: '0' }}>
              New Trigger
            </Button>
          </HeaderRow>
        )}
        <div
          style={{
            height: this.props.height - 300 + 'px',
            // maxHeight: height - 50,
            overflowY: 'auto',
          }}
        >
          <div>{toTriggerRows(filter)(save)(triggers)}</div>
        </div>
      </div>
    )
  }
}
//

export default Trigger
